import './markdown-deck.ts'

import { MarkdownDeck } from './markdown-deck'

export default MarkdownDeck
